import { render, staticRenderFns } from "./EditPromotionBaseSettingsDermo.vue?vue&type=template&id=b2c7cf8e&"
import script from "./EditPromotionBaseSettingsDermo.vue?vue&type=script&lang=js&"
export * from "./EditPromotionBaseSettingsDermo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports